"use strict";
angular.module('newWeiboDiscloseModule', [])
    .controller("newWeiboDiscloseCtrl", ["$scope", "$timeout", "$modalInstance", "params", "$validation", "$q", "trsHttpService", "modalDialog", function($scope, $timeout, $modalInstance, params, $validation, $q, trsHttpService, modalDialog) {
        initStatus();

        function initStatus() {
            $scope.status = {
                title: "新增"
            };
            $scope.data = {
                name: "",
                account: ""
            };
            $scope.showHelp = false;
        }
        $scope.confirm = function(next) {
            $validation.validate($scope.nweWeiboForm).success(function() {
                submit($scope.data).then(function(data) {
                    modalDialog.alertType("新增成功", "", "success", false);
                    if (next) {
                        $scope.data.name = "";
                        $scope.data.account = "";
                        $scope.hideInput = true; //处理连续新增时表单校验错误问题
                        $timeout(function() {
                            console.log($scope.nweWeiboForm);
                            $scope.hideInput = false; //处理连续新增时表单校验错误问题
                        });
                    } else {
                        $modalInstance.close();
                    }
                });
            }).error(function() {});
        };
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [查询微博爆料配置列表]
         * @return {[type]} [description]
         */
        function submit(item) {
            var defer = $q.defer();
            var params = {
                "serviceid": "mlf_tenant",
                "methodName": "saveMicroBlogAccount",
                "MICROBLOGACCOUNT": item.account,
                "MICROBLOGNAME": item.name,
                "TENANTMICROBLOGBURSTID": 0
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }
    }]);